var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.structuralElement
    ? _c("sidebar-widget", {
        attrs: {
          id: "courseware-action-widget",
          title: _vm.$gettext("Aktionen"),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "widget-list widget-links cw-action-widget",
                    },
                    [
                      _vm.canEdit
                        ? _c(
                            "li",
                            {
                              staticClass: "cw-action-widget-add",
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.addElement,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$gettext("Seite hinzufügen")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "cw-action-widget-export",
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: _vm.exportElement,
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Seite exportieren")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1052831555
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }